module.exports = __webpack_public_path__ + "assets/img/dx22.98956abe.jpg";